<template>
  <div style="overflow-x: scroll;width:750px;" class="printed-div">
    <div class="border--primary pa-2 mx-3 my-5">
      <v-layout row wrap>
        <v-flex xs4>
          <v-img class="img-print" :src="company.logo_url" height="80px" contain></v-img>
        </v-flex>
        <v-flex xs8>
          <div class="headline font-weight-bold text-xs-center" primary-title>
            {{ company.title }}
          </div>
          <div class="subheading mt-1 ">
            <span class="greyDarken2--text">{{
              $t("screener.physical.tickets.event")
            }}</span
            >&nbsp;-&nbsp;<span class="title">{{
              booking.screener_title
            }}</span>
          </div>
          <div class="subheading">
            <span class="greyDarken2--text">{{
              $t("screener.physical.tickets.time")
            }}</span
            >&nbsp;-&nbsp;<span class="title">{{
              moment
                .utc(booking.screener_start_date)
                .local()
                .format("lll")
            }}</span>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="my-2" />
      <v-layout row wrap>
        <v-flex xs4 v-if="screener.physical_venue">
          <v-btn v-if="screener.physical_venue.navigation_link" color="primary"
            ><v-icon small>$vuetify.icons.rms_navigation</v-icon
            ><a
              class="white--text ml-1"
              :href="screener.physical_venue.navigation_link"
              target="_blank"
              >{{ $t("screener.physical.tickets.navigate") }}</a
            ></v-btn
          >
        </v-flex>
        <v-flex xs8 class="subheading" v-if="screener.physical_venue">
          <div class="subheading">
            {{ $t("screener.physical.tickets.consumer") }}&nbsp;-&nbsp;<span>{{
              consumer_email
            }}</span>
          </div>
          <div>
            {{ $t("screener.physical.tickets.venue") }}&nbsp;-&nbsp;{{
              screener.physical_venue.name
            }}
          </div>
          <div>
            {{ $t("screener.physical.tickets.address") }}&nbsp;-&nbsp;{{
              screener.physical_venue.address
            }}
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="my-2" />
      <v-layout row wrap>
        <v-flex xs4 class="text-xs-center">
          <vue-qrcode class="img-print" :value="qrCode" :options="{ width: 200 }"></vue-qrcode>
        </v-flex>
        <v-flex xs8>
          <v-data-table
            v-if="booking"
            :headers="headers"
            :items="booking.seat_indexes"
            hide-actions
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ getSeatCategory(props.item) }}</td>
                <td>{{ getSeatDiscountType(props.item) }}</td>
                <td>{{ getSeatLabel(props.item) }}</td>
                <td>{{ getSeatPrice(props.item) }}</td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td>
                  <h4>
                    {{
                      $t("screener.physical.tickets.total_seats")
                    }}&nbsp;:&nbsp;
                  </h4>
                </td>
                <td>
                  <h4 v-if="booking.seat_indexes">
                    {{ booking.seat_indexes.length }}
                  </h4>
                </td>
                <td></td>
              </tr>
              <!-- Total amount without discount -->
              <tr>
                <td>
                  <h4>
                    {{
                      $t("screener.physical.tickets.total_amount")
                    }}&nbsp;:&nbsp;
                  </h4>
                </td>
                <td>
                  <h4>
                    {{ getCurrencySymbol(booking.currency)
                    }}{{ booking.amount }}
                  </h4>
                </td>
                <td></td>
              </tr>
              <!-- Coupon discounted amount -->
                <tr v-if="booking.coupon_discount">
                    <td><h4>{{$t('screener.physical.tickets.discount')}}&nbsp;:&nbsp;</h4></td>
                    <td colspan="2">
                        <h4>
                            <span v-if="booking.currency">-{{ getCurrencySymbol(booking.currency) }}</span>
                            <span>{{couponDiscount}}</span>
                        </h4>
                    </td>
                </tr>
                <!-- Total paid after discount -->
                <tr v-if="booking.coupon_discount">
                    <td ><h4>{{$t('screener.physical.tickets.total_paid')}}&nbsp;:&nbsp;</h4></td>
                    <td colspan="2">
                        <h4>
                            <span v-if="booking.currency">{{getCurrencySymbol(booking.currency)}}</span>
                            <span>
                               {{totalPrice}}
                            </span>
                        </h4>
                    </td>
                </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <div
        class="text-align"
        v-if="screener.physical_venue && screener.physical_venue.notes"
      >
        <h3>{{ $t("screener.physical.tickets.notes") }}&nbsp;:-</h3>
        <p>{{ screener.physical_venue.notes }}</p>
      </div>
      <div class="grey lighten-4 mt-2">
        <div class="text-xs-center">
          <v-img
            class="img-print"
            src="@/assets/communicada-color.png"
            height="40px"
            contain
          ></v-img>
          <div v-html="$t('rms.footer.powered_by')"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { utcToTz } from "@/helper";
import { mapGetters } from "vuex";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { seatCategoryMethods } from "@/mixins/seats";
import { currencySymbol } from "@/mixins/currencySymbol";
import DEFINES from "@/defines";

export default {
  props: {
    booking: {
      type: Object,
      default: null,
    },
    screener: {
      type: Object,
      default: null,
    },
    qrCode: {
      type: String,
      default: null,
    },
    consumer_email: {
      type: String,
      default: null,
    },
  },
  mixins: [currencySymbol, seatCategoryMethods],
  name: "Ticket",
  components: {
    VueQrcode,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('screener.seats.category.title'),
          align: "left",
          sortable: false,
          value: "category",
        },
        {
          text: this.$t('screener.seats.discounts.title'),
          align: "left",
          sortable: false,
          value: "discounts",
        },
        {
          text: this.$t('screener.seats.label.title'),
          align: "left",
          sortable: false,
          value: "label",
        },
        {
          text: this.$t('screener.seats.price.title'),
          align: "left",
          sortable: false,
          value: "price",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
      company: "getSelectedCompany",
    }),
    couponDiscount(){
      return this.booking.amount * (this.booking.coupon_discount / 100);
    },
    totalPrice(){
        let total = this.booking.amount;
        total = total - (total < this.couponDiscount? total :  this.couponDiscount);
        return total.toFixed(2);
    }
  },
  methods: {
    getSeatLabel(seatId) {
      let seats = this.booking.seat_labels;
      return seats[seatId].label;
    },
    getSeatPrice(seatId) {
      let discounts = this.booking.ticket_types_discount;
      let price = this.booking.seat_labels[seatId].price;
      let discount = 0;
      if (discounts && !Array.isArray(discounts) && discounts[seatId]) {
        discount =
          price *
          (this.screener.physical_venue_ticket_types_discount[
            discounts[seatId]
          ] /
            100);
        price = (price - discount).toFixed(2);
      }
      return this.getCurrencySymbol(this.company.currency) + price;
    },
    getSeatCategory(seatId) {
      let category = this.booking.seat_labels[seatId].category;
      let categoryObj = this._categoryClassifier(category);
      return categoryObj.label;
    },
    getSeatDiscountType(seatId) {
      let discounts = this.booking.ticket_types_discount;
      if (discounts && !Array.isArray(discounts) && discounts[seatId]) {
        let discountId = discounts[seatId];
        return DEFINES.SEAT_TICKET_TYPES_LABEL[discountId];
      }
      return "-";
    },
  },
};
</script>
<style scoped>
.border--primary {
  border: 2px solid grey;
}
.border-primary-right {
  border-right: 2px solid grey;
}
.text-align {
  text-align: justify;
}

@media all{
   printed-div{
       display:none;
   }
}
@media print{
   printed-div{
       display:block;
   }
   .img-print{
       display: list-item;
       list-style-position: inside;
       -webkit-print-color-adjust: exact !important;
   }
}
</style>
